<template>
    <div class="col mt-4">
        <div class="c-service c-service--active">
            <div
                class="c-service__basic"
                :class="{
                    row: service.graphics && service.graphics.smallIconMinioUrl
                }"
            >
                <div
                    class="col-4"
                    v-if="
                        service.graphics && service.graphics.smallIconMinioUrl
                    "
                >
                    <router-link
                        :to="goToServiceDetails()"
                    >
                        <img
                            :src="service.graphics.smallIconMinioUrl"
                            alt
                            class="img-fluid"
                        />
                    </router-link>
                </div>
                <div
                    class="col-8"
                    v-if="
                        service.graphics && service.graphics.smallIconMinioUrl
                    "
                >
                    <h2 class="c-service__title">
                        <router-link
                            :to="goToServiceDetails()"
                        >
                            {{ service.name }}
                        </router-link>
                    </h2>
                    <p class="c-service__status">
                        Usługa jest
                        <strong>{{ activeWord }}</strong>
                    </p>
                </div>
                <template v-else>
                    <h2 class="c-service__title">
                        <router-link
                            :to="goToServiceDetails()"
                        >
                            {{ service.name }}
                        </router-link>
                    </h2>
                    <p class="c-service__status">
                        Usługa jest
                        <strong>{{ activeWord }}</strong>
                    </p>
                </template>
            </div>

            <div class="c-service__desc" v-html="service.description">
                <p>
                    Usługa umożliwia nadawanie i odbieranie paczek tylko przy
                    użyciu kasy fiskalnej. Niewielka ilość miejsca (ok. 0,5 m2)
                    oraz dobra lokalizacja pozwoli zwiększyć obroty, pozyskać
                    dodatkowych klientów i rozwinąć biznes o dodatkową
                    działalność.
                </p>
            </div>

            <h3 class="c-service__sub">
                <router-link
                    :to="goToServiceDetails()"
                >
                    Dowiedz się więcej
                </router-link>
            </h3>

            <ul class="c-service__list">
                <li v-if="benefits">
                    <router-link
                        :to="goToServiceDetails('#benefity')"
                    >
                        Sprawdź benefity
                    </router-link>
                </li>
                <li>
                    <router-link
                        :to="goToServiceDetails('#dokumenty')"
                    >
                        Pokaż dokumenty
                    </router-link>
                </li>
                <li
                    v-if="
                        service.number_of_entities_with_subscription > 0 &&
                            isLocationLevelService
                    "
                >
                    <a>
                        Aktywowano w
                        <strong>
                            {{ service.number_of_entities_with_subscription }}
                        </strong>
                        {{
                            service.number_of_entities_with_subscription === 1
                                ? 'sklepie'
                                : 'sklepach'
                        }}
                    </a>
                </li>
            </ul>

            <div class="c-service__actions justify-content-end">
                <div
                    class="d-flex flex-wrap justify-content-center"
                    style="width: max-content"
                >
                    <button
                        v-if="
                            serviceCustomAction &&
                                service.number_of_entities_with_subscription > 0
                        "
                        type="button"
                        class="btn btn-secondary m-1 px-5"
                        @click="
                            isLotteryUser
                                ? $store.dispatch('onLotteryUserNoPermission')
                                : goToServiceClickHandler()
                        "
                        style="flex: 1"
                    >
                        Przejdź
                    </button>
                    <router-link
                        v-if="
                            service.number_of_entities_with_subscription > 0 &&
                                !this.isAvailableSection
                        "
                        class="btn btn-secondary m-1"
                        :to="goToServiceDetails()"
                        style="flex: 1"
                    >
                        Zarządzaj usługą
                    </router-link>

                    <template v-else>
                        <template v-if="service.activation_type === 'A'">
                            <button
                                type="button"
                                class="btn btn-secondary m-1"
                                @click="activateService"
                            >
                                Włącz usługę
                            </button>
                        </template>
                        <template v-else>
                            <button
                                style="opacity: 0.6"
                                v-tooltip="
                                    'Funkcjonalność będzie dostępna w kolejnych wersjach aplikacji'
                                "
                                type="button"
                                class="btn btn-secondary m-1"
                            >
                                Włącz usługę
                            </button>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        service: {
            type: Object,
            require: true
        },
        isAvailableSection: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        serviceCustomAction() {
            return this.servicesWithCustomAction[this.service.code]
        },
        servicesWithCustomAction() {
            return this.$store.getters.getServicesWithCustomAction
        },
        activeWord() {
            return this.service.number_of_entities_with_subscription > 0
                ? 'aktywna'
                : 'nieaktywna'
        },
        benefits() {
            return this.service.description_long.includes('id="benefity"')
        },
        isLocationLevelService() {
            return this.service.level === 'Location'
        }
    },
    methods: {
        goToServiceClickHandler() {
            if (this.serviceCustomAction.link) {
                window.location.href = this.serviceCustomAction.link
            }
        },
        activateService() {
            if (this.isLotteryUser && this.service.code !== 'loterie2_g3') {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                this.$store.dispatch('openModal', {
                    component: 'AcceptService',
                    args: {
                        fetchService: true,
                        service: this.service,
                        allShops: !this.isLocationLevelService,
                        isCheckedAllInactive: this.isLocationLevelService
                    }
                })
            }
        },
        goToServiceDetails(hash) {
            return { name: 'service', params: { id: this.service.id }, hash: hash }
        }
    }
}
</script>
